import React, { useEffect, useState } from "react";
import { LinearGradient } from "react-text-gradients";
import SideBar from "../../Common/SideBar";
import { useDispatch, useSelector } from "react-redux";
import {
  collapseSidebar,
  expandSidebar,
} from "../../../store/reducers/sidebarSlice";
import {
  accountType,
  convertToFirestoreTimestamp,
  firestoreCollections,
  formatFirebaseTimestampForChat,
  withdrawReqStatus,
} from "../../../utils";
import {
  collection,
  deleteDoc,
  doc,
  getDoc,
  onSnapshot,
  query,
  updateDoc,
  where,
} from "firebase/firestore";
import { db } from "../../../config/firebase";
import {
  errorToast,
  infoToast,
  successToast,
} from "../../../services/toastService";
import { ThreeDotLoader } from "../../Common/Loaders";
import { sendNotification } from "../../../services/firebaseService";

const EachWithdrawalRequest = ({ request, index }) => {
  const [transactionId, setTransactionId] = useState("");
  const [reqActionLoading, setReqActionLoading] = useState(false);

  const handleApproveRequest = async () => {
    if (!transactionId) infoToast("Please add transaction ID to submit.");
    else {
      try {
        setReqActionLoading(true);
        const requestRef = doc(
          db,
          firestoreCollections.merchantWithdrawals,
          request.id
        );
        const updatedData = {
          status: withdrawReqStatus.APPROVED,
          paymentId: transactionId,
          approvedAt: convertToFirestoreTimestamp(new Date()),
        };

        await updateDoc(requestRef, updatedData).then(async () => {
          const merchantRef = doc(
            db,
            firestoreCollections.merchants,
            request.merchantId
          );

          const newAmount = parseFloat(
            parseFloat(
              request.merchantData?.amtWithdrawn
                ? request.merchantData?.amtWithdrawn
                : 0
            ) + parseFloat(request.withdrawAmount)
          ).toFixed(2);
          const newWalletBalance = parseFloat(
            parseFloat(request.merchantData.walletBalance) -
              parseFloat(request.withdrawAmount)
          ).toFixed(2);

          const updatedMerchData = {
            amtWithdrawn: newAmount,
            walletBalance: newWalletBalance,
          };

          await updateDoc(merchantRef, updatedMerchData);
          successToast("Withdrawal request approved.");

          const notificationData = {
            title: "Admin has approved your withdrawal request.",
            body: `Amount of SAR ${request.withdrawAmount} has been credited to your given account.`,
            accType: accountType.MERCHANT,
            userId: request.merchantId,
          };
          sendNotification(notificationData);
        });
      } catch (error) {
        errorToast("Internal server error");
        console.log(error, "<<< error approving merchant");
      } finally {
        setReqActionLoading(false);
      }
    }
  };

  const handleDenyRequest = async () => {
    try {
      setReqActionLoading(true);
      const requestRef = doc(
        db,
        firestoreCollections.merchantWithdrawals,
        request.id
      );
      const updatedData = {
        status: withdrawReqStatus.REJECTED,
        rejectedAt: convertToFirestoreTimestamp(new Date()),
      };
      await updateDoc(requestRef, updatedData);
      infoToast("Withdrawal request denied.");
    } catch (error) {
      errorToast("Internal server error");
      console.log(error, "<<< error approving merchant");
    } finally {
      setReqActionLoading(false);
    }
  };

  return (
    <div className="verificationTableRow">
      <div
        style={{ width: "6%", height: "100%" }}
        className="eachColumn eachTableBody"
      >
        {index}
      </div>
      <div
        style={{
          width: "16%",
          height: "100%",
          textDecoration: "underline",
          whiteSpace: "nowrap",
        }}
        className="eachColumn eachTableBody"
      >
        {request.merchantData.displayName}
      </div>
      <div
        style={{ width: "14%", height: "100%" }}
        className="eachColumn eachTableBody"
      >
        {request.merchantData.phoneNumber}
      </div>
      <div
        style={{ width: "18%", height: "100%" }}
        className="eachColumn eachTableBody"
      >
        {request.IBAN}
      </div>
      <div
        style={{ width: "13%", height: "100%" }}
        className="eachColumn eachTableBody"
      >
        {request.withdrawAmount} SAR
      </div>
      <div
        style={{ width: "13%", height: "100%" }}
        className="eachColumn eachTableBody"
      >
        {formatFirebaseTimestampForChat(request.createdAt)}
      </div>
      <div
        style={{
          width: "16%",
          height: "100%",
          textDecoration: "underline",
          color: "#3366CC",
        }}
        className="eachColumn eachTableBody"
      >
        <input
          style={{
            width: "100%",
            height: "100%",
            boxSizing: "border-box",
            color: "#565656",
            fontFamily: "Poppins, sans-serif",
            fontWeight: 600,
            fontSize: "1.8vh",
            textAlign: "center",
          }}
          // defaultValue={merchant.projectFeesToAdmin}
          onChange={e => setTransactionId(e.target.value)}
          placeholder="Enter transaction id"
        />
      </div>
      <div
        style={{
          width: "18%",
          height: "100%",

          justifyContent: "space-evenly",
        }}
        className="eachColumn eachTableBody"
      >
        {reqActionLoading ? (
          <ThreeDotLoader visible={true} color="#3366CC"/>
        ) : (
          <>
            {" "}
            <div
              style={{
                color: transactionId ? "#008000" : "#56565699",
                textDecoration: "underline",
              }}
              onClick={handleApproveRequest}
            >
              Approve
            </div>
            <div
              style={{
                color: "red",
                textDecoration: "underline",
              }}
              onClick={handleDenyRequest}
            >
              Deny
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default function WithdrawalScreen() {
  const sidebar = useSelector(state => state.sidebar);
  const dispatch = useDispatch();
  console.log(sidebar.expand, "<<< sidebar");
  const [timeFrame, setTimeFrame] = useState("Day");
  const [merchWithdrawalRequests, setMerchWithdrawalRequests] = useState([]);

  const fetchMerchantWithdrawalRequests = () => {
    const q = query(
      collection(db, firestoreCollections.merchantWithdrawals),
      where("status", "==", withdrawReqStatus.PENDING)
    );

    const unsubscribe = onSnapshot(q, async querySnapshot => {
      const newData = await Promise.all(
        querySnapshot.docs.map(async merchWithdrawalDoc => {
          const reqData = merchWithdrawalDoc.data();
          reqData.id = merchWithdrawalDoc.id;
          const merchDoc = await getDoc(
            doc(db, firestoreCollections.merchants, reqData.merchantId)
          );
          reqData.merchantData = merchDoc.data();
          return reqData;
        })
      );

      setMerchWithdrawalRequests(newData);
      console.log(newData);
    });

    return unsubscribe;
  };

  useEffect(() => {
    const unsubscribe = fetchMerchantWithdrawalRequests();

    return () => {
      unsubscribe();
    };
  }, []);

  return (
    <div className="MainContainer">
      <SideBar />
      <div
        style={{ width: sidebar.expand ? "84vw" : "95vw" }}
        className="ScreenContainer"
      >
        {/* upper search bar start */}

        <div className="upperSearchBarContainer">
          <div className="upperBarSearchBar">
            <input placeholder="Search..." className="upperBarSearchBarInput" />
          </div>
          <div className="upperBarSearchBox upperBarSearchBoxNotification">
            <img
              src={require("../../../assets/exit.png")}
              alt="notification-bell"
            />
          </div>
          <div
            className="upperBarSearchBox upperBarSearchBoxProfile"
            style={{ border: "none" }}
          >
            <img
              src={require("../../../assets/profile.png")}
              alt="profile-pic"
            />
          </div>
        </div>

        {/* page heading start */}

        <div className="pageHeadingContainer">
          <div className="pageHeadingInnerContainer">
            <img
              src={require("../../../assets/dashboardColourIcon.png")}
              alt="profile-pic"
              className="pageHeadingImageDashboard"
            />
            <div className="pageHeading">
              <LinearGradient gradient={["to left", "#03BAF9,#7B32EE"]}>
                Withdrawal Requests
              </LinearGradient>
            </div>
          </div>
          <div className="pageHeadingSecondaryText">Settings/General</div>
        </div>
        {/* general numbers container start */}

        <div className="verificationTableContainer">
          <div className="verificationTableRow">
            <div
              style={{ width: "6%", height: "100%" }}
              className="eachColumn eachTableHead"
            >
              Sr. No.
            </div>
            <div
              style={{ width: "16%", height: "100%" }}
              className="eachColumn eachTableHead"
            >
              Partner Name
            </div>
            <div
              style={{ width: "14%", height: "100%" }}
              className="eachColumn eachTableHead"
            >
              Phone Number
            </div>
            {/* <div
              style={{ width: "15%", height: "100%" }}
              className="eachColumn eachTableHead"
            >
              Date Joined
            </div> */}
            <div
              style={{ width: "18%", height: "100%" }}
              className="eachColumn eachTableHead"
            >
              IBAN
            </div>
            <div
              style={{ width: "13%", height: "100%" }}
              className="eachColumn eachTableHead"
            >
              Amount
            </div>
            <div
              style={{ width: "13%", height: "100%" }}
              className="eachColumn eachTableHead"
            >
              Req time
            </div>
            <div
              style={{ width: "16%", height: "100%" }}
              className="eachColumn eachTableHead"
            >
              Transaction Id
            </div>
            <div
              style={{
                width: "18%",
                height: "100%",
              }}
              className="eachColumn eachTableHead"
            ></div>
          </div>
          {merchWithdrawalRequests.map((request, i) => (
            <EachWithdrawalRequest
              key={request.id}
              index={i + 1}
              request={request}
            />
          ))}

          {/* <EachWithdrawalRequest />
          <EachWithdrawalRequest /> */}
        </div>
      </div>
    </div>
  );
}
